
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextInput from "@/components/TextInput.vue";
import DropDownInput from "@/components/DropDownInput.vue";
import { userService } from "@/services/user.service";
import { pinboardService } from "@/services/pinboard.service";
import { PinBoard } from "@/models/pinboard.model";
import { User } from "@/models/user.model";
import store from "@/store/store";
import { faUnderline } from '@fortawesome/free-solid-svg-icons';
import { cardService } from '../../services/card.service';
import { CardModel } from '../../models/card.model';
require("@/assets/css/modal.scss");

@Component(
    {
        components : {
            TextInput,
            DropDownInput,
        }
    }
)
export default class CardModal extends Vue{
    @Prop() private id!: number;
    showContent:boolean = false;
    pinboards:PinBoard[] = [{ id:1, name:"Tavla 1" }];
    selectedPinboard:any = [];
    user:User = { companyId:this.$store.getters["app/companyId"]};
    newPassword:string = "";

    roles:string[] = ["user", "admin"];
    selectedRole?:string[] = [];
    errors: string[] = [];
    file: any;

    userImageSourceFromBase64:string = "";

    get cardName(){
        return ((this.user.firstName ? this.user.firstName : "")  + (this.user.lastName ? " " + this.user.lastName : ""));
    }

    @Watch("cardName")
    cardNameChanged(val:any){
        this.user.cardName = val;
    }

    async created(){
        this.pinboards = await pinboardService.getAllKeyValue(this.$store.getters["app/companyId"]);
        this.selectedRole = [];
        this.selectedPinboard = [];
        this.errors = [];
        this.newPassword = "";
        this.userImageSourceFromBase64 = "";

        if(this.id != 0){
            this.user = await userService.getDetails(this.id);

            if(this.user.cardId){
                let userCard:CardModel = await cardService.get(this.user.cardId)
                this.selectedPinboard = userCard.pinBoardIds;
                this.user.cardPinBoardLocking = userCard.cardPinBoardLocking;
            }

            this.selectedRole = this.user.roles;
        }
        else{
            this.user = {companyId:this.$store.getters["app/companyId"], cardPinBoardLocking:false};
        }
    }

    async save(){
        store.dispatch("app/resetErrors");
        this.user.roles = this.selectedRole;
        this.user.pinBoardIds = this.selectedPinboard;
        userService.create(this.user).then((response) => {
            this.user.id = response.data;
            if(this.file && !this.user.image){
                this.createImage();
            }
            //todo upload image for user with id appUserId
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Användare skapad',
                duration: 5000,
                type: 'success',
            });

            this.$emit("modalEmit", 'saved', this.user.id);
        });
    }

    async updateUserPassword(){
        store.dispatch("app/resetErrors");
        let result = await userService.updateUserPassword({ userId: this.user.id, newPassword: this.newPassword });
        if(result){
            this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Lösenord ändrat',
                    duration: 5000,
                    type: 'success',
                });
        }
        // userService.resetUserPassword(this.user, this.newPassword).then((response) => {
        //         this.user.id = response.data;
        //         this.$notify({
        //             group: 'message',
        //             title: 'Succe!',
        //             text: 'Lösenord ändrat',
        //             duration: 5000,
        //             type: 'success',
        //         });
        // });
    }

    async createImage(){
            let formData = new FormData();
            formData.append('file', this.file);
            await userService.createImage(formData, this.user.id!);
            this.newImage = false;
    }

    async updateImage(){
            let formData = new FormData();
            formData.append('file', this.file);
            await userService.updateImage(formData, this.user.id!);
            this.newImage = false;
    }

    close(){
        this.showContent = false;
        this.$emit("modalEmit", 'close');
    }

    async update(){
        store.dispatch("app/resetErrors");
        this.user.roles = this.selectedRole;
        this.user.pinBoardIds = this.selectedPinboard;


        userService.update(this.user).then((response) => {
            if(this.file){
                if(this.user.image){
                    this.updateImage();
                }
                else{
                    this.createImage();
                }
            }
            
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Användare uppdaterad',
                duration: 5000,
                type: 'success',
            });
            this.$emit("modalEmit", 'saved');
        });
    }


    newImage:boolean = false;
    // REGION image upload
    processFile(event:any) {
        this.errors = [];
        this.file = event.target.files[0];
        if(!this.file.name.toLowerCase().includes(".png") 
        && !this.file.name.toLowerCase().includes(".gif") 
        && !this.file.name.toLowerCase().includes(".jpg") 
        && !this.file.name.toLowerCase().includes(".gif")){
            this.errors.push("Endast jpg, gif, png tillåtna");
        }

        this.newImage = true;
        this.userImageSourceFromBase64 = URL.createObjectURL(this.file);
    }

    // ENDREGION image upload

    @Watch('errors')
    async errorListChanged(){
        if(this.errors.length > 0){
            this.$notify({
                group: 'message',
                title: 'Något gick fel',
                text: this.errors.join(" "),
                duration: 5000,
                type: 'error',
            });
        }
    }

    // @Watch('id')
    // async idChanged(){
    //     this.errors = [];
    //     this.newPassword = "";
    //     this.userImageSourceFromBase64 = "";
    //     if(this.id != 0){
    //         this.user = await userService.getDetails(this.id);

    //         if(this.user.cardId){
    //             let userCard:CardModel = await cardService.get(this.user.cardId)
    //             this.selectedPinboard = userCard.pinBoardIds;
    //             this.user.cardPinBoardLocking = userCard.cardPinBoardLocking;
    //         }

    //         this.selectedRole = this.user.roles;
    //     }
    //     else{
    //         this.user = {companyId:this.$store.getters["app/companyId"], cardPinBoardLocking:false};
    //     }
    // }
}
